var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCreateReq(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 54,
    viewBox: "0 0 55 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 54,
    height: 54,
    rx: 27,
    fill: "#F6F7FE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_75_8776)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.0175 18.249H38.75C39.0815 18.249 39.3995 18.3807 39.6339 18.6151C39.8683 18.8496 40 19.1675 40 19.499V36.999C40 37.3305 39.8683 37.6485 39.6339 37.8829C39.3995 38.1173 39.0815 38.249 38.75 38.249H16.25C15.9185 38.249 15.6005 38.1173 15.3661 37.8829C15.1317 37.6485 15 37.3305 15 36.999V16.999C15 16.6675 15.1317 16.3496 15.3661 16.1151C15.6005 15.8807 15.9185 15.749 16.25 15.749H25.5175L28.0175 18.249ZM17.5 18.249V35.749H37.5V20.749H26.9825L24.4825 18.249H17.5ZM26.25 26.999V23.249H28.75V26.999H32.5V29.499H28.75V33.249H26.25V29.499H22.5V26.999H26.25Z",
    fill: "#4361EE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_75_8776"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(12.5 12)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateReq);
export default __webpack_public_path__ + "static/media/create_req.03fd09b217ba661353bcc2d1c987b6b8.svg";
export { ForwardRef as ReactComponent };